const state = {
    userInfo: window.localStorage.getItem('outsideUserInfo') ? JSON.parse(window.localStorage.getItem('outsideUserInfo')) : null,
}
const mutations = {
    outside_setUserInfo(state, data) {
        state.userInfo = data;
        window.localStorage.setItem('outsideUserInfo', JSON.stringify(data));
    },
    outside_removeInfo(state) {
        state.userInfo = null;
        window.localStorage.removeItem('outsideUserInfo');
    }
}
const actions = {
    outside_setUserInfo({ commit }, t) {
        commit('outside_setUserInfo', t)
    },
    outside_removeInfo({ commit }, t) {
        commit('outside_removeInfo', t)
    }
}

export default {
    state,
    mutations,
    actions
}